import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  InputAdornment,
} from "@mui/material";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import HubIcon from "@mui/icons-material/Hub";

export default function AuthScreen({ onLogin }) {
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!apiKey.trim()) return;
    setLoading(true);
    await onLogin(apiKey.trim());
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0B0F19",
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 420,
          width: "100%",
          bgcolor: "#111827",
          border: "1px solid rgba(255, 255, 255, 0.06)",
          borderRadius: "16px",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Box component="img" src="/logo.png" alt="OtimizAPP HUB" sx={{ width: 88, height: 88, borderRadius: 2, mb: 1 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: "#F3F4F6" }}>
              OtimizAPP HUB
            </Typography>
            <Typography variant="body2" sx={{ color: "#6B7280", mt: 0.5 }}>
              Hub de Conexoes Multi-Canal & VoIP
            </Typography>
          </Box>

          <form onSubmit={handleSubmit} autoComplete="off">
            <TextField
              fullWidth
              label="API Key"
              placeholder="hub_xxxxxxxxxxxxxxxx"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              variant="outlined"
              autoComplete="off"
              inputProps={{ autoComplete: "off" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VpnKeyIcon sx={{ color: "#6B7280", fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  bgcolor: "#1E293B",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.08)" },
                  "&:hover fieldset": { borderColor: "rgba(255,107,0,0.3)" },
                  "&.Mui-focused fieldset": { borderColor: "#FF6B00" },
                },
                "& .MuiInputLabel-root.Mui-focused": { color: "#FF6B00" },
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading || !apiKey.trim()}
              sx={{
                py: 1.3,
                fontSize: "0.95rem",
                bgcolor: "#FF6B00",
                borderRadius: "10px",
                "&:hover": { bgcolor: "#E06000" },
                "&.Mui-disabled": { bgcolor: "#333", color: "#666" },
              }}
            >
              {loading ? "Autenticando..." : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
